import { configureStore } from '@reduxjs/toolkit'
import authenticationReducer from "./features/auth/authenticationSlice"
import permissionsReducer from "./data/permissions/permissionsSlice"
import opportunitiesReducer from './data/opportunities/opportunitiesSlice';
import quoteRevisionNotesReducer from './features/quotes/data/quoteRevisionNotesSlice';

export default configureStore({
    reducer: {
        authentication: authenticationReducer,
        permissions: permissionsReducer,
        opportunities: opportunitiesReducer,
        quoteRevisionNotes: quoteRevisionNotesReducer
    }
});
